/**
 * @file: 在线会话相关接口
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2022-05-24 17:45:31
 * @LastEditors: wangzhenhai02@baidu.com
 * @LastEditTime: 2022-06-21 10:04:59
 * @FilePath: /console-znzs/src/api/chat.js
 */
// yapi地址: https://yapi.baidu-int.com/project/18492/interface/api/1552067

import request from '@/znzs/src/utils/request';

/**
 * 发起在线人工会话（触发坐席分配）
 * @author https://yapi.baidu-int.com/project/18492/interface/api/1565199
 * @param {*} data (productId: 产品类型; questionId: 问题类型id; scene: 场景, userName: 用户名称)
 * @returns
 */
export const getIMSessions = data => request.post('/im-sessions/allocate', data);

/**
 * 发送消息
 * @author https://yapi.baidu-int.com/project/18492/interface/api/1554814
 * @param {*} data
 * @returns
 */
export const sendMessage = data => request.post('/im-dialogs/message', data);

/**
  * @description: 获取我的会话列表
  * @param {*} 查询参数
  * @return {*} list
  */
export function getSessionLists(params) {
    return request({
        url: '/im-sessions',
        method: 'GET',
        params,
    });
}

/**
  * @description: 获取会话详情
  * @param {*} 会话id
  * @return {*} 会话详情obj
  */
export function getSessionDetails(id) {
    return request({
        url: `/im-sessions/${id}`,
        method: 'GET',
    });
}

/**
  * @description: 获取全部云产品工单产品类型、问题类型列表
  * @param {*} none
  * @return {*} list
  */
export function getAllTicketsProductQuestionTypes() {
    return request({
        url: '/question-types',
        method: 'GET',
    });
}

/**
 * @description: 获取工单推荐产品类型
 * @return {*}
 */
export function getTicketRecommendationRroductTypeList() {
    return request({
        url: '/ticket-recommendation-product-type-list',
        method: 'GET',
    });
}

/**
  * @description: 用户是否在客服会话中
  * @return {*}
  */
export function isInSession() {
    return request({
        url: '/is-in-im-session',
        method: 'GET',
    });
}

/**
  * @description: 评价客服
  * @param {*} starRating: 星级评定; sessionId: IM会话id; evaluation: 评价标签列表
  */
export function evaluateCS(data) {
    return request({
        url: '/evaluate/cs',
        method: 'POST',
        data,
    });
}

/**
  * @description: 获取当前会话详情
  * @param {*} none
  * @return {*} 会话详情
  */
export function getCurrentSessionDetails() {
    return request({
        url: '/sessions/latest',
        method: 'GET',
    });
}

/**
  * @description: 更改转人工消息的点击状态
  * @param {*} productId:
  * @return {*} bool
  */
export function isClicked(id, data) {
    return request({
        url: `/im-dialogs/${id}/status`,
        method: 'PUT',
        data,
    });
}

/**
 * @description: 标记单条消息为已读
 * @param {*} id: 消息id，即dialogId
 * @param {*} status: 0表示未读，1表示已读
 */
export function cleanSingleUnreadMsg(id, data) {
    return request({
        url: `/im-dialogs/${id}/status`,
        method: 'PUT',
        data,
    });
}

/**
 * @description: 将会话未读消息清零
 * @param {*} id 会话id
 */
export function cleanUnreadMsg(id) {
    return request({
        url: `/im-sessions/${id}/clean`,
        method: 'PUT',
    });
}
